export const textTruncateMore = (string: any, length: any) => {
  if (string?.length > length) return string.substring(0, length) + "...";
  else return string;
};
